<template>
    <div class="container-fluid mt-2">
      <div class="form-group row">
        <div class="col-sm-2 text-md-right text-sm-center">
          <label>Número Protocolo:</label>
        </div>
        <div class="col-md-8 col-sm-10">
          <div class="form-group input-group" :class="{
            'form-group--error': $v.apensar.processoApensado.$error
          }">
            <auto-complete-comp
              class="form__input autocomplete w-100"
              :isAsync="true"
              :url="urlAutoComplete"
              :width="100"
              :marginBottom="10"
              mutation="MUT_APENSAR_PROCESSO_SELECIONADO"
              keyAttrName="id"
              keyAttrFilter="numeroProcesso"
              valueAttrName="processo"
              :params="autoCompleteParams">
            </auto-complete-comp>
          </div>
          <div class="error" v-if="!$v.apensar.processoApensado.required">{{ errorMessage }}</div>
        </div>
        <div class="col-md-2 col-sm-12 text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-primary mb-1" @click.prevent="adicionar">Adicionar</button>
        </div>
      </div>
    </div>
</template>

<script>
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'

import eventBus from '@/uteis/eventBus'

import VirtusService from '@/services/VirtusService'

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  name: 'formularioApensar',

  components: {
    autoCompleteComp
  },

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String },
    eventBusRecarregar: { required: true, type: String }
  },

  data () {
    return {
      formulario: {
        offset: 1,
        range: this.rowsNumber
      },
      autoCompleteParams: {
        numeroProcesso: '',
        numeroGuia: '',
        remetente: '',
        municipio: '',
        assunto: '',
        interessado: '',
        autoComplete: true
      },
      errorMessage: 'O campo é obrigatório',
      apensar: {
        processoApensado: '',
        processo: ''
      },
      processoSelecionado: {},
      urlAutoComplete: '/d0593/pae-back/v1/protocolos/setor/parent'
    }
  },

  created () {
    this.service = new VirtusService()

    this.apensar.processo = this.$route.query.numeroProcesso
    var sessao = this.$store.getters.getDadosSessao.sessao

    this.autoCompleteParams.tipoIdentificador = 'ID'
    this.autoCompleteParams.identificador = sessao.idDepartamento

    this.apensar.solicitante = {
      tipo: 'PESSOA',
      titulo: sessao.nomeUsuario,
      identificador: sessao.login,
      tipoIdentificador: 'LOGIN'
    }
  },

  validations: {
    apensar: {
      processoApensado: {
        required
      }
    }
  },

  computed: mapState({
    processoApensado: state => state.apensarProcessoSelecionado.processo,
    processoSelecionadoApensacao: state => state.apensarProcessoSelecionado
  }),

  watch: {
    processoApensado (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$v.apensar.processoApensado.$model = newValue
      }
    },
    processoSelecionadoApensacao (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.processoSelecionado = newValue
      }
    }
  },

  methods: {

    async adicionar () {
      this.errorMessage = 'O campo é obrigatório'

      const { APENSAR_PROTOCOLO } = rules
      if (!componentIsVisible(APENSAR_PROTOCOLO)) {
        this.errorMessage = 'Não pode apensar um protocolo, pois não tem permissão'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.$v.$touch()
        return
      }

      if (this.apensar.processoApensado === this.apensar.processo) {
        this.errorMessage = 'Não pode apensar o mesmo número de protocolo'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.$v.$touch()
        return
      }

      if (this.isApensado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo já apensado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      if (this.isApensando(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo que já está apensando outro'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      if (this.isAnexado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo já anexado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      if (this.isArmazenado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo armazenado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      if (this.isArquivado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo arquivado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      if (this.isEliminado(this.processoSelecionado)) {
        this.errorMessage = 'Não pode apensar um protocolo eliminado'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      try {
        const processos = await this.service.getInstanciaProtocolo({
          ...this.autoCompleteParams,
          numeroProcesso: this.apensar.processo
        })
        const processo = processos.data[0]
        if (processo.atributos.tipoProtocolo !== 'Processo' || this.processoSelecionado.atributos.tipoProtocolo !== 'Processo') {
          this.errorMessage = 'O protocolo pai e o protocolo apensado precisam ser do tipo Processo'
          this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
          this.$v.apensar.processoApensado.$model = ''
          this.processoSelecionado = {}
          this.$v.$touch()
          return
        }
      } catch (error) {
        this.errorMessage = 'Aconteceu um erro na verificação dos protocolos, se persistir entre em contato com a equipe de suporte'
        this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
        this.$v.apensar.processoApensado.$model = ''
        this.processoSelecionado = {}
        this.$v.$touch()
        return
      }

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.service.existeDocumentoExterno(this.apensar.processoApensado).then((resp) => {
        if (resp) {
          this.service.apensar(this.apensar).then((response) => {
            eventBus.$emit(this.eventBusRecarregar, response)
          })
        } else {
          this.errorMessage = 'Não pode apensar um protocolo sem documento externo'
          this.$store.commit('MUT_LIMPAR_PROTOCOLO_APENSADO_SELECIONADO')
          this.$v.apensar.processoApensado.$model = ''
          this.processoSelecionado = {}
          this.$v.$touch()
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== '',
    isApensando: (obj) => obj.apensados,
    isArmazenado: (obj) => obj.atributos ? obj.atributos.armazenado : false,
    isArquivado: (obj) => obj.atributos && obj.atributos.arquivado,
    isEliminado: (obj) => obj.atributos && obj.atributos.remocao
  }
}
</script>

<style lang="stylus" scoped>

</style>
